/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteMcpEndpointSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteMcpEndpointSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteMcpEndpointSecurity = {
  option1?: DeleteMcpEndpointSecurityOption1 | undefined;
  option2?: DeleteMcpEndpointSecurityOption2 | undefined;
};

export type DeleteMcpEndpointRequest = {
  /**
   * The ID of the MCP endpoint to delete
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteMcpEndpointSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteMcpEndpointSecurityOption1$outboundSchema: z.ZodMiniType<
  DeleteMcpEndpointSecurityOption1$Outbound,
  DeleteMcpEndpointSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteMcpEndpointSecurityOption1ToJSON(
  deleteMcpEndpointSecurityOption1: DeleteMcpEndpointSecurityOption1,
): string {
  return JSON.stringify(
    DeleteMcpEndpointSecurityOption1$outboundSchema.parse(
      deleteMcpEndpointSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteMcpEndpointSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteMcpEndpointSecurityOption2$outboundSchema: z.ZodMiniType<
  DeleteMcpEndpointSecurityOption2$Outbound,
  DeleteMcpEndpointSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function deleteMcpEndpointSecurityOption2ToJSON(
  deleteMcpEndpointSecurityOption2: DeleteMcpEndpointSecurityOption2,
): string {
  return JSON.stringify(
    DeleteMcpEndpointSecurityOption2$outboundSchema.parse(
      deleteMcpEndpointSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteMcpEndpointSecurity$Outbound = {
  Option1?: DeleteMcpEndpointSecurityOption1$Outbound | undefined;
  Option2?: DeleteMcpEndpointSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteMcpEndpointSecurity$outboundSchema: z.ZodMiniType<
  DeleteMcpEndpointSecurity$Outbound,
  DeleteMcpEndpointSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteMcpEndpointSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteMcpEndpointSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteMcpEndpointSecurityToJSON(
  deleteMcpEndpointSecurity: DeleteMcpEndpointSecurity,
): string {
  return JSON.stringify(
    DeleteMcpEndpointSecurity$outboundSchema.parse(deleteMcpEndpointSecurity),
  );
}

/** @internal */
export type DeleteMcpEndpointRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteMcpEndpointRequest$outboundSchema: z.ZodMiniType<
  DeleteMcpEndpointRequest$Outbound,
  DeleteMcpEndpointRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteMcpEndpointRequestToJSON(
  deleteMcpEndpointRequest: DeleteMcpEndpointRequest,
): string {
  return JSON.stringify(
    DeleteMcpEndpointRequest$outboundSchema.parse(deleteMcpEndpointRequest),
  );
}
